import { jsxs as i, jsx as a } from "react/jsx-runtime";
import { useChatbotContext as n } from "../../hooks/useChatbotContext.js";
import { BotMessageAvatar as o } from "./BotMessageAvatar.js";
function p() {
  const { chatbot: e, cn: m, formatDate: r, thinkingTimestamp: t } = n();
  return /* @__PURE__ */ i(
    "div",
    {
      className: m(
        "flex flex-row items-center gap-2.5 text-[14.5px] leading-[1.21] @notMobile:text-[13px] min-[409px]:max-[409px]:text-[13px]",
        { "mb-[5px]": e == null ? void 0 : e.avatarUrl, "mb-2.5": !(e != null && e.avatarUrl) }
      ),
      children: [
        /* @__PURE__ */ a(o, {}),
        /* @__PURE__ */ a("p", { className: "line-clamp-2 grow font-medium", "data-testid": "chatbot-name", children: e == null ? void 0 : e.publicName }),
        t ? /* @__PURE__ */ a(
          "time",
          {
            dateTime: t.toISOString(),
            className: "text-muted-foreground",
            children: r(t, "h:mmaaa")
          }
        ) : null
      ]
    }
  );
}
export {
  p as BotThinkingHeader
};
